// extracted by mini-css-extract-plugin
export default {"tupacGrid":"xs-z","tupacHeader":"ys-z","tupacHeader2":"zs-z","tupacMenu":"As-z","tupacMenu2":"Bs-z","tupacMain":"Cs-z","tupacMain2":"Ds-z"};